const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16
  })
})

export default styles



// WEBPACK FOOTER //
// ./src/components/unauthorized/styles.js